module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/Rubels-3289234fe8e0aa3c9ca10c6d73a7f1b3.png";